import { TemplateLink } from "./TemplateLink"

export default function StartStopContinueContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Start / Stop / Continue is the plain white t-shirt of retrospective
        formats. Nobody's quite sure who invented it, and it's been sitting
        quietly in team-facilitation manuals since at least the 1970s. What we
        can say confidently: it survives because <em>what's working, what's
        not, what's confusing</em> covers most of the meeting anyway.
      </p>

      <h2>When to use this format</h2>
      <p>
        Reach for it when your team is new to retros, or when you have fifteen
        minutes and can't afford to teach anyone a new format. People intuit
        the three columns before you finish explaining them, which means more
        of the meeting is spent talking about the actual work and less about
        the meeting itself. Retroboard's session timer helps keep that
        fifteen-minute discipline honest.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it if your team is bored of it. No format survives its fifth
        consecutive appearance. Skip it right after a rough launch, too;{" "}
        <TemplateLink to="mad-sad-glad">Mad / Sad / Glad</TemplateLink> does
        a better job surfacing the feelings that are quietly driving everyone's
        decisions right now.
      </p>

      <h2>How to run it</h2>
      <p>
        Ten minutes of silent writing per column, then group similar items
        and vote. Discuss the top three. Before anyone leaves the Zoom, name
        an owner for the highest-voted Start and Stop items. Actions without
        owners are wishes.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The Continue column fills up with polite noise. <em>Continue
        standups!</em> Sure. Push people to write only what's genuinely worth
        protecting, the things they'd fight for if someone tried to take them
        away. If nobody objects, it wasn't worth writing.
      </p>
    </>
  )
}
